import { ArrowUpDown } from 'lucide-react';
import { Button } from '@/components/ui/button';
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from '@/components/ui/dropdown-menu';

interface SortOption {
  label: string;
  value: string;
}

interface SortPickerProps {
  options: SortOption[];
  current: string;
  onChange: (value: string) => void;
}

export function SortPicker({ options, current, onChange }: SortPickerProps) {
  const currentLabel = options.find((o) => o.value === current)?.label ?? 'Sort';

  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="outline" size="sm" className="h-8 gap-1.5 text-xs">
          <ArrowUpDown className="h-3 w-3" />
          {currentLabel}
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-48">
        {options.map((opt) => (
          <DropdownMenuItem
            key={opt.value}
            onClick={() => onChange(opt.value)}
            data-active={current === opt.value}
            className="data-[active=true]:font-semibold"
          >
            {opt.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
